"use strict";
define(
'stores/streaks',[
    "stores/store",
    "actions/streaks",
    "constants/actiontypes"
],
function (StoreBase, Action, Constants)
{
    Store.prototype = new StoreBase();
    Store.constructor = Store;

    function Store (params)
    {
        // Call parent constructor
        StoreBase.call(this, params);

        // Setup the instance
        this.streaks = [];

        // Memoize some values because these wont change often
        this.longestActivityDailyStreak = null;
        this.currentActivityDailyStreak = null;
        this.currentActivityWeekStreak = null;

        this.registerDispatchListener(function (action) {
            switch(action.actionType) {
                case Constants.ADD_STREAKS:
                    this.streaks = [];
                    if (Array.isArray(action.data)) {
                        _.each(action.data, this.addStreak.bind(this));
                    } else {
                        this.addStreak(action.data);
                    }
                    
                    // Adding new streaks affects memoized values so reset them
                    this.longestActivityDailyStreak = null;
                    this.currentActivityDailyStreak = null;
                    this.currentActivityWeekStreak = null;
                    this.event.emit("change");
                    break;
            }
        }.bind(this));

        this.action = new Action();
    }

    Store.prototype.addStreak = function(data)
    {
        this.streaks.push(data);
    };

    Store.prototype.getAll = function()
    {
        this.streaks;
    };

    Store.prototype.getLongestStreak = function(type, unit) {
        type = type || 'activity';
        unit = unit || 'daily';
        let longestStreak = null;
        this.streaks.forEach(function(streak) {
            if(streak.type === type && streak.unit === unit) {
                if(longestStreak === null) {
                    longestStreak = streak;
                } else if(longestStreak.length < streak.length) {
                    longestStreak = streak;
                }
            }
        });

        return longestStreak;
    }

    Store.prototype.getMostRecentStreak = function(type, unit) {
        type = type || 'activity';
        unit = unit || 'daily';
        for (var streak of this.streaks) {
            if(streak.type === type && streak.unit === unit) {
                return streak;
            }
        }

        return null;
    }

    Store.prototype.getCurrentStreak = function(type, unit) {
        type = type || 'activity';
        unit = unit || 'daily';

        var mostRecentStreak = this.getMostRecentStreak(type, unit);

        if (mostRecentStreak === null) {
            return null;
        }
        
        /**
         * Date produces output in the local time of the computer it's running on.
         * Since our db is runing on UTC time, the calculated diffUnits may be off if the created_at time is within +/- timezone offset 
         * Change all times to utc to be in sync with the db to prevent this issue
         */
        var now = new Date();
        var utcNow = new Date(now.getTime() + now.getTimezoneOffset() * 60 * 1000);
        var streakCreatedAt = new Date(mostRecentStreak.created_at);
        var utcStreakCreatedAt = new Date(streakCreatedAt.getTime() + streakCreatedAt.getTimezoneOffset() * 60 * 1000);

        // Reset all times to beginning of day to make math easier
        utcNow.setHours(0,0,0,0);
        utcStreakCreatedAt.setHours(0,0,0,0);

        // If unit is week, then also reset to beginning of week
        if (unit === 'week') {
            var first = utcNow.getDate() - utcNow.getDay();
            utcNow = new Date(utcNow.setDate(first));

            var first = utcStreakCreatedAt.getDate() - utcStreakCreatedAt.getDay();
            utcStreakCreatedAt = new Date(utcStreakCreatedAt.setDate(first));
        }

        var diffTime = Math.abs(utcNow - utcStreakCreatedAt);

        // The divisor changes dependning on our unit
        var divisor = (1000 * 60 * 60 * 24);
        if (unit === 'weekly') {
            divisor = divisor * 7;
        }

        var diffUnits = Math.ceil(diffTime / divisor); 

        // The difference in unit + length of streak should be equal to the now or one unit less than now
        diffUnits = diffUnits - mostRecentStreak.length;

        if(diffUnits <= 0) {
            return mostRecentStreak;
        }

        return null;
    }

    Store.prototype.getCurrentActivityDailyStreak = function() {
        if(this.currentActivityDailyStreak) {
            return this.currentActivityDailyStreak;
        }

        var streak = this.getCurrentStreak('activity', 'daily');

        this.currentActivityDailyStreak = streak;

        return streak;
    }

    Store.prototype.getCurrentActivityWeeklyStreak = function() {
        if(this.currentActivityWeeklyStreak) {
            return this.currentActivityWeeklyStreak;
        }

        var streak = this.getCurrentStreak('activity', 'weekly');

        this.currentActivityWeeklyStreak = streak;

        return streak;
    }

    Store.prototype.getLongestActivityDailyStreak = function() {
        if(this.longestActivityDailyStreak) {
            return this.longestActivityDailyStreak;
        }

        var streak = this.getLongestStreak('activity', 'daily');

        this.longestActivityDailyStreak = streak;

        return streak;
    }

    return Store;
});

